import React, { useEffect } from "react";
import { Nav } from "@/components/prometheus/Nav";
import { SecondBrain3DStudio } from "@/components/prometheus/SecondBrain3DStudio";

export const SecondBrainPage: React.FC = () => {
  useEffect(() => {
    document.title = "Segundo Cerebro 3D — Prometheus Lab AI";
  }, []);

  return (
    <main className="min-h-screen bg-[#050811] text-white overflow-hidden flex flex-col">
      <Nav />
      <div className="pt-16 flex-1 w-full relative">
        <SecondBrain3DStudio initialDomain="prometheus" />
      </div>
    </main>
  );
};

export default SecondBrainPage;
